import Vue from 'vue'

// Components
export * from './components'

// Design system components (global registration)
import { BBCheckbox, BBRadio, BBButton } from './components'
Vue.component('b-checkbox', BBCheckbox)
Vue.component('b-radio', BBRadio)
Vue.component('b-button', BBButton)

// Store
export * from './store'

// Styles
import './styles/main.scss'

// Constants
export * from './constants'

// Types
export * from './store/techpack/techpack.types'
export * from './types'

// Services
export { identify, recordPageInAnalytics } from './services/analytics/analytics.service'
export { identifySegmentUser } from './services/analytics/segment.service'
export { setDataDogUser } from './services/analytics/data-dog.service'
export { http } from './services/http'

// Utils
export * from './utils'

// Composables
export * from './composables'
